
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalWindow from '@/ui/components/components/ModalWindow.vue';
import OfflineChart from '@/ui/components/devices/previews/charts/components/OfflineChart.vue';

/**
 * Component that represent PVSystem device
 */
@Component({
  components: {
    ModalWindow,
    OfflineChart,
  },
})
export default class PVSystemCharts extends Vue {
  isTooltip = false;

  // contains Chart Object
  get mockChartData() {
    let currentChartOptions: any = [];
    currentChartOptions = [
      {
        agg: 'first',
        name: this.$t('devices.PVSystem.ChartsWindow.seriesTitles.actualPower'),
        scaling: {
          max: '100',
          min: '0',
        },
        seriesType: 'View',
        type: 'line',
        unit: 'kW',
        var: '',
      }, {
        agg: 'first',
        name: this.$t('devices.PVSystem.ChartsWindow.seriesTitles.actualVoltage'),
        scaling: {
          max: '100',
          min: '0',
        },
        seriesType: 'View',
        type: 'line',
        unit: 'kW',
        var: '',
      }, {
        agg: 'first',
        name: this.$t('devices.PVSystem.ChartsWindow.seriesTitles.currentFlow'),
        scaling: {
          max: '100',
          min: '0',
        },
        seriesType: 'View',
        type: 'line',
        unit: 'kW',
        var: '',
      },
    ];

    const currentData = {
      data: {
        chartOptions: currentChartOptions,
        selectedStackingOptions: 'normal',
        selectedWidth: 'full',
        type: 'chart',
      },
      created_at: '2021-10-07T07:43:33.554983Z',
    };
    return currentData;
  }
}
